import React from 'react';
import { SortableElement } from 'react-sortable-hoc';

import RowService from './Service';
import RowCategory from './Category';

const SortableItem = SortableElement(({ row, ...props }) => {
  const { collection } = row;
  switch (collection) {
  case 'category':
    return <RowCategory category={row} {...props} />;
  case 'service':
    return <RowService service={row} {...props} />;
  default:
    return 'Not found collection'
  }
});

export default SortableItem;
